export default "__VITE_ASSET__405e0e46__"